import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import BingAdsAnalytics from './plugins/bingAdsAnalytics';
import VueGoogleApi from 'vue-google-api'
import Tawk from './plugins/tawk'
import Meta from './plugins/meta'
import VueAnalytics from 'vue-analytics'
//import TrackJS from './plugins/trackJS'
import RollbarAPI from './plugins/rollbar'
import HotJar from './plugins/hotJar'
import i18n from './i18n'
import VueTyperPlugin from 'vue-typer'
import UnitedAnalytics from './plugins/unitedAnalytics';


Vue.config.productionTip = false;

const googleAPIConfig = {
  'apiKey': 'AIzaSyBJ7FEd40aQL6J1d7a8Nopy3MGPBJM0umw',
  'clientId': '777751714840-ta88b7tkbdr6f4dcp6tsth6acpeqe08h.apps.googleusercontent.com',
  'scope': 'email',
  'discoveryDocs': []
};
Vue.use(UnitedAnalytics);
//Vue.use(TrackJS, {token: '0bdd42900b37474094c27f44bcd04bd2'});
Vue.use(RollbarAPI, {token: '1c8f6d348e804085864ef882b11b9d0b'});
Vue.use(Meta, { titlePrefix: 'GameEnable - '});
Vue.use(VueTyperPlugin);
Vue.use(BingAdsAnalytics);

//Discovery docs'"https://www.googleapis.com/discovery/v1/apis/people/v1/rest"'
Vue.use(VueGoogleApi, googleAPIConfig);
Vue.use(HotJar);
Vue.use(VueAnalytics, {
  id: 'UA-180985422-1',
  router,
  autoTracking: {
    page: true,
    skipSamePath: true
  }
});



Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5f8f53f8f91e4b431ec62a64/default'
});


// Register a global custom directive called `v-focus`
Vue.directive('ga-event', {
  // When the bound element is inserted into the DOM...
  inserted: function (el, binding) {
    el.addEventListener('click', ()=>Vue.$ga.event(...binding.value));

  }
});




new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
